<template>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import firebase from 'firebase';

    import LoginForm from './forms/LoginForm';
    import RegistrationForm from './forms/RegistrationForm';
    import PasswordForm from './forms/PasswordForm';


    @Component
    export default class Authentication extends Vue {
        name = 'authentication';
        authComponent = LoginForm;

        created() {
            var user = firebase.auth().currentUser;
            if (user) {
                this.$router.go('/');
            }
        }

        switchAuthComponent(value) {
            this.authComponent = value;
        }
    }

    Vue.component(Authentication.name, Authentication);
</script>



// WEBPACK FOOTER //
// src/components/auth/Authentication.vue